'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Function for analytics tracking.
 *
 * "pathname" is the current URL being requested.
 *
 */

var track = function track(_ref) {
  var pathname = _ref.pathname;

  if (typeof window !== 'undefined') {
    var ga = window[window['GoogleAnalyticsObject'] || 'ga'];
    if (typeof ga === 'function') ga('send', 'pageview', pathname);
  }
};

exports.default = track;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/redux/middlewares/analytics/track.js
// module id = 1297
// module chunks = 0